import dayjs from "dayjs";

export interface ReadEmailRecord {
  id: string;
  timestamp: number;
}

/**
 * ローカルストレージは基本的に利用したくないが、
 * 個々のユーザーが特定のメールを気軽に非表示、表示またはお気に入り、お気に入り解除できるようにするために、DB等工数を抑えるために使用する。
 */
export default class LocalStorageEmails {
  private storageKey: string;
  /**
   * @param {String} storageKey
   */
  constructor(storageKey: string) {
    this.storageKey = storageKey;
  }
  /**
   * メールIDをローカルストレージに追加
   * @param {String} emailId
   */
  appendEmailId(emailId: string): void {
    const existEmails = this.getEmailIds();
    const newEmails = [emailId, ...existEmails];
    localStorage.setItem(this.storageKey, JSON.stringify(newEmails));
  }
  /**
   * メールID一覧を取得する
   * @return {String[]} メールID一覧
   */
  getEmailIds(): string[] {
    const existEmails = localStorage.getItem(this.storageKey);
    return existEmails ? JSON.parse(existEmails) : [];
  }
  /**
   * 指定のメールIDがローカルストレージにセットされているかどうか
   * @param {String} emailId
   * @return {Boolean} メールIDが既に存在するかどうか
   */
  existEmailId(emailId: string): boolean {
    const existEmails = this.getEmailIds();
    return existEmails.includes(emailId);
  }
  /**
   * 指定したメールIDを削除する
   * @param {String} emailId
   */
  removeEmailId(emailId: string): void {
    const existEmails = this.getEmailIds();
    const setEmails = existEmails.filter((id: string) => id !== emailId);
    localStorage.setItem(this.storageKey, JSON.stringify(setEmails));
  }
  /**
   * ローカルストレージにセットされたメールID一覧をリセットする
   */
  resetEmailIds(): void {
    localStorage.removeItem(this.storageKey);
  }

  /**
   * メールIDとタイムスタンプをローカルストレージに追加
   * @param {String} emailId
   */
  appendEmailIdWithTimestamp(emailId: string): void {
    const existEmails = this.getEmailIdRecords();
    const newEmail = { id: emailId, timestamp: dayjs().valueOf() };
    const newEmails = [newEmail, ...existEmails];
    localStorage.setItem(this.storageKey, JSON.stringify(newEmails));
  }

  /**
   * メールIDとタイムスタンプ一覧を取得する
   * @return {ReadEmailRecord[]} メールIDとタイムスタンプ一覧
   */
  getEmailIdRecords(): ReadEmailRecord[] {
    const emailRecords = localStorage.getItem(this.storageKey);
    return emailRecords ? JSON.parse(emailRecords) : [];
  }

  /**
   * 指定時間より古い記録を削除する
   * @param {Number} cutoff 期限切れの時間
   * @return {ReadEmailRecord[]} 削除後のメールIDとタイムスタンプ一覧
   */
  filterExpiredEmailIdRecords(cutoff: number): ReadEmailRecord[] {
    const records = this.getEmailIdRecords();
    const filteredRecords = records.filter(r => r.timestamp >= cutoff);
    if (filteredRecords.length < records.length) {
      localStorage.setItem(this.storageKey, JSON.stringify(filteredRecords));
    }
    return filteredRecords;
  }
}
